import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import '../../services/GlobalVariables';
import axios from 'axios';

const API_URL = global.SET_API_URL + 'takeawayCounters/';

const initialState = {
    counters: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ''
};

export const fetchTakeawayCounters = createAsyncThunk(
    'takeawayCounters/fetchAll',
    async (_, thunkAPI) => {
        try {
            const res = await axios.get(API_URL + 'list');
            return res.data.counters || [];
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const createTakeawayCounter = createAsyncThunk(
    'takeawayCounters/create',
    async (payload, thunkAPI) => {
        try {
            const res = await axios.post(API_URL + 'create', payload);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateTakeawayCounter = createAsyncThunk(
    'takeawayCounters/update',
    async ({ takeawayCounterId, data }, thunkAPI) => {
        try {
            const res = await axios.put(API_URL + `update/${takeawayCounterId}`, data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateTakeawayCounterStatus = createAsyncThunk(
    'takeawayCounters/status',
    async (payload, thunkAPI) => {
        try {
            const res = await axios.put(API_URL + 'status', payload);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteTakeawayCounter = createAsyncThunk(
    'takeawayCounters/delete',
    async (takeawayCounterId, thunkAPI) => {
        try {
            const res = await axios.delete(API_URL + `delete/${takeawayCounterId}`);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

const takeawayCounterSlice = createSlice({
    name: 'takeawayCounters',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = false;
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTakeawayCounters.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchTakeawayCounters.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.counters = action.payload;
            })
            .addCase(fetchTakeawayCounters.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(createTakeawayCounter.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createTakeawayCounter.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(createTakeawayCounter.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(updateTakeawayCounter.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateTakeawayCounter.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(updateTakeawayCounter.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(updateTakeawayCounterStatus.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateTakeawayCounterStatus.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(updateTakeawayCounterStatus.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(deleteTakeawayCounter.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteTakeawayCounter.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(deleteTakeawayCounter.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            });
    }
});

export const { reset } = takeawayCounterSlice.actions;
export default takeawayCounterSlice.reducer;
